export const setCalendar = ({ commit }, payload) => {
  commit('SET_CALENDAR', payload)
}
export const addCalendar = ({ commit }, payload) => {
  commit('ADD_CALENDAR', payload)
}
export const setCalendarLoading = ({ commit }, payload) => {
  commit('SET_CALENDAR_LOADING', payload)
}

export const setClients = ({ commit }, payload) => {
  commit('SET_CLIENTS', payload)
}
export const addClients = ({ commit }, payload) => {
  commit('ADD_CLIENTS', payload)
}
export const setClientsLoading = ({ commit }, payload) => {
  commit('SET_CLIENTS_LOADING', payload)
}
